/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/library/reportcard/carddetail/carddetail_styles';



/* ========== ~~~~~~~~~~ REPORT CARD DETAIL ~~~~~~~~~~ ========== */
const CardDetail = (props) => (
    <div className={`card-detail ${props.classes.carddetail} ${props.type.toLowerCase()}`}>
        <div className={`detail-label`}><h4>{props.label}</h4></div>
        <div className={`detail-data`}><p>{props.data[props.type] ? props.data[props.type] : 'N/A'}</p></div>
    </div>
);



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(CardDetail);
